import { Box, Flex, Heading, HStack, Button } from '@chakra-ui/react'
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react'
import { Link } from 'react-router-dom'

interface LayoutProps {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <Box minH="100vh" bg="gray.50">
      <Flex
        as="header"
        bg="white"
        borderBottomWidth="1px"
        borderColor="gray.200"
        px={6}
        py={3}
        alignItems="center"
        justifyContent="space-between"
      >
        <Link to="/">
          <Heading size="md" color="blue.600">
            Dominus
          </Heading>
        </Link>

        <HStack gap={4}>
          <SignedIn>
            <Link to="/chat">
              <Button variant="ghost" size="sm">
                Chat
              </Button>
            </Link>
            <Link to="/email">
              <Button variant="ghost" size="sm">
                Email
              </Button>
            </Link>
            <Link to="/settings/voice">
              <Button variant="ghost" size="sm">
                Voice
              </Button>
            </Link>
            <UserButton afterSignOutUrl="/" />
          </SignedIn>
          <SignedOut>{/* Sign in button is on landing page */}</SignedOut>
        </HStack>
      </Flex>

      <Box as="main">{children}</Box>
    </Box>
  )
}
